module.exports = __webpack_public_path__ + "img/home1.f0bf5c2a.jpg";